import i18n from "@assessment/i18n";

const isNotProd = ["dev", "development", "staging"].includes(
  import.meta.env.MODE
);

const featureNameKeyMapping: Record<string, string> = {
  hitachi: "assessment.featureNames.knowledgeCheck",
  "hitachi-academy": "assessment.featureNames.knowledgeCheck",
  "gl-japan": isNotProd
    ? "assessment.featureNames.knowledgeCheck"
    : "assessment.featureNames.assessment",
  "t-mobile": "assessment.featureNames.assessment",
  "gl-india": "assessment.featureNames.assessment",
  default: "assessment.featureNames.assessment"
};

const orgBasedFeatureNameMapping = new Proxy(featureNameKeyMapping, {
  get(target, prop: string) {
    const key = target[prop] ?? target.default;
    return i18n.t(key);
  }
}) as Record<string, string>;

export default orgBasedFeatureNameMapping;
